import ModalShell from "../../../../_components/modal/ModalShell";
import ConfirmDialog from "../../../../_components/modal/ConfirmDialog";
import DynamicForm from "../../../../_components/form/DynamicForm";
import { useMarketFormSchema } from "./hooks/useMarketFormSchema";
import { useMarketFormState } from "./hooks/useMarketFormState";
import "./_market-form-modal.scss";

/**
 * UI Layer - presentational composition only, mirrors
 * _features/company/modals/CompanyFormModal/index.jsx exactly. Every
 * business decision (schema post-processing, unsaved-changes tracking,
 * submit orchestration) lives in ./utils/marketFormRules.js and ./hooks/*;
 * this file just wires their outputs into JSX. Schema post-processing
 * (multiSelect forcing for the country field) happens inside
 * useMarketFormSchema itself, before resolution - see its own docstring
 * for why it can't happen here, after the schema is already resolved.
 */
const MarketFormModal = ({ isOpen, onClose, rowData, mode, onSuccess, refetchFilters }) => {
  const processedFormSchema = useMarketFormSchema(rowData);

  const {
    control,
    formData,
    errors,
    handleChange,
    handleBlur,
    showCloseConfirmation,
    isSubmitting,
    attemptClose,
    confirmDiscard,
    cancelDiscard,
    onSubmit,
  } = useMarketFormState(processedFormSchema, { mode, rowData, isOpen, onClose, onSuccess, refetchFilters });

  return (
    <>
      <ModalShell
        isOpen={isOpen}
        onRequestClose={attemptClose}
        width="460px"
        height="100vh"
        center={false}
        right={0}
        className="market-form-modal--right-docked"
        title={mode === "edit" ? "Edit market" : "New market"}
        description={
          mode === "edit"
            ? "Updates this region's billing currency and tax rule."
            : "Open a region for billing with its own currency and tax rule."
        }
        isSubmitting={isSubmitting}
        footerButtons={[
          { children: "Close", onClick: attemptClose, variant: "outlined" },
          {
            children: mode === "edit" ? "Update" : "Create",
            onClick: onSubmit,
            variant: "contained",
            loading: isSubmitting,
          },
        ]}
      >
        <form onSubmit={onSubmit}>
          <DynamicForm
            schema={processedFormSchema}
            control={control}
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            handleBlur={handleBlur}
            mode={mode}
            disabled={isSubmitting}
          />
        </form>
      </ModalShell>

      <ConfirmDialog
        isOpen={showCloseConfirmation}
        title="Discard unsaved changes?"
        description="You have unsaved changes. Are you sure you want to close without saving?"
        cancelText="Keep editing"
        confirmText="Discard changes"
        onCancel={cancelDiscard}
        onConfirm={confirmDiscard}
      />
    </>
  );
};

export default MarketFormModal;
